import { render, staticRenderFns } from "./AvatarGuest.vue?vue&type=template&id=d3b2e7e6&"
import script from "./AvatarGuest.vue?vue&type=script&lang=js&"
export * from "./AvatarGuest.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGuest.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports